/**
 * Drawer: нет вишлиста
 *
 * Показывается когда пользователь пытается добавить желание,
 * но у него ещё нет ни одного вишлиста.
 * Объясняет ситуацию и предлагает создать вишлист.
 */

import { useRouterNavigation, ROUTE_PATHS } from '@/lib';
import { useTranslation } from 'react-i18next';
import { BaseDrawer } from '@/components';
import { Button } from '@/components/ui/button';
import { useNoWishlistDrawer } from './useAppActions';

export function NoWishlistDrawer(): JSX.Element {
  const { t } = useTranslation();
  const { open, setOpen } = useNoWishlistDrawer();
  const navigation = useRouterNavigation();

  const handleConfirm = () => {
    setOpen(false);
    navigation.navigate(ROUTE_PATHS.WISHLIST_NEW, { state: { nextAction: 'addWish' } });
  };

  return (
    <BaseDrawer
      open={open}
      onOpenChange={setOpen}
      title={t('wishlist:noWishlistDrawer.title')}
      showTitle
      footer={
        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={() => setOpen(false)}
            className="flex-[1]"
          >
            {t('common:cancel')}
          </Button>
          <Button
            onClick={handleConfirm}
            className="flex-[2]"
          >
            {t('wishlist:noWishlistDrawer.confirm')}
          </Button>
        </div>
      }
    >
      <p className="text-foreground text-base px-4">
        {t('wishlist:noWishlistDrawer.description')}
      </p>
    </BaseDrawer>
  );
}
